"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inputLabel = void 0;
const tv_1 = require("../utils/tv");
exports.inputLabel = (0, tv_1.tv)({
  base: `
    pointer-events-none absolute m-none block text-secondary transition-all
    duration-200
    peer-required:after:content-["*"]
    peer-hover:text-primary peer-hover:peer-[&:user-invalid]:text-critical
    peer-focus:peer-hover:text-secondary
    peer-focus:peer-hover:peer-[&:user-invalid]:text-critical
    peer-[&:user-invalid]:text-critical
  `,
  variants: {
    floating: {
      false: `
        left-[0.85rem] top-md text-md leading-md tracking-md
        peer-focus:top-xs peer-focus:text-xs peer-focus:leading-xs
        peer-focus:tracking-lg peer-focus:peer-[[size=small]]:top-xs
        peer-[[size=small]]:top-sm
      `,
      true: `
        left-[0.85rem] top-xs text-xs leading-xs tracking-lg
        peer-[[size=small]]:top-xs
      `
    }
  },
  defaultVariants: {
    floating: false
  }
});
